"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  Card: true,
  LinkCard: true,
  ButtonCard: true
};
exports.LinkCard = exports.Card = exports.ButtonCard = void 0;
var _Card = require("./Card");
var _interfaces = require("./interfaces");
Object.keys(_interfaces).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _interfaces[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _interfaces[key];
    }
  });
});
const Card = exports.Card = (0, _Card.createCardComponent)({
  interactive: false,
  name: 'Card',
  tag: 'div'
});
const LinkCard = exports.LinkCard = (0, _Card.createCardComponent)({
  // Remove styles inherited from <a>
  additionalStyles: {
    textDecoration: 'unset'
  },
  interactive: true,
  name: 'LinkCard',
  tag: 'a'
});
const ButtonCard = exports.ButtonCard = (0, _Card.createCardComponent)({
  interactive: true,
  name: 'ButtonCard',
  tag: 'button'
});